import { useDeviceType } from '@cian/ui-kit';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectTestOnboarding } from '../../selectors/onboarding/selectTestOnboarding';
import { fetchGetDesktopOnboardingsSafe } from '../../services/safeApi/fetchGetDesktopOnboardingsSafe';
import { fetchGetMobwebOnboardingsSafe } from '../../services/safeApi/fetchGetMobwebOnboardingsSafe';
import { TOnboardingData } from '../../types/onboarding';
import { useApplicationContext } from '../../utils/applicationContext';
import { useTypeSafeApiResult } from '../../utils/typesafe-result';

export function useOnboardingData(): TOnboardingData | null {
  const ctx = useApplicationContext();
  const [onboardingData, setOnboardingData] = useState<TOnboardingData | null>(null);
  const deviceType = useDeviceType();
  const testOnboarding = useSelector(selectTestOnboarding);
  const { data: desktopData, safeFetch: fetchDesktopData } = useTypeSafeApiResult(fetchGetDesktopOnboardingsSafe);
  const { data: mobwebData, safeFetch: fetchMobwebData } = useTypeSafeApiResult(fetchGetMobwebOnboardingsSafe);

  useEffect(() => {
    if (testOnboarding !== null) {
      setOnboardingData(testOnboarding);
    }
  }, [testOnboarding]);

  useEffect(() => {
    if (desktopData !== undefined && desktopData.onboardingData && desktopData.onboardingId) {
      setOnboardingData({
        ...desktopData.onboardingData,
        id: desktopData.onboardingId,
      });
    }
  }, [desktopData]);

  useEffect(() => {
    if (mobwebData !== undefined && mobwebData.onboardingData && mobwebData.onboardingId) {
      setOnboardingData({
        ...mobwebData.onboardingData,
        id: mobwebData.onboardingId,
      });
    }
  }, [mobwebData]);

  useEffect(() => {
    if (testOnboarding === null) {
      if (deviceType === 'phone') {
        fetchMobwebData(ctx);
      } else {
        fetchDesktopData(ctx);
      }
    }
    // специально исключаем из зависимостей deviceType, чтобы не делать запрос данных
    // при изменении ширины экрана
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx, fetchDesktopData, fetchMobwebData, testOnboarding]);

  return onboardingData;
}
